export const checkValidInvoiceCorrection = (order) =>
	order._ticket?.find((ticket) => ticket.valid_invoice?.correction_number);
